export default __webpack_public_path__ + "img/92f4159c874ab84bd29b15f9aea9f505.svg";